import request from '@/utils/request'

// 获取订单详情
export function getList(data) {
  return request({
    url:'/Crm.Orders/orderDetails',
    method:'post',
    data:data
  })
}

// 新建订单
export function ordersAdd(data) {
  return request({
    url:'/Crm.Orders/addOrder',
    method:'post',
    data:data
  })
}

// 订单修改
export function ordersUpdate(data) {
  return request({
    url:'/Crm.Orders/modifyOrderHeader',
    method:'post',
    data:data
  })
}

// 刷新价格
export function refreshPrice(data) {
  return request({
    url:'/Crm.Orders/refreshPrice',
    method:'post',
    data:data
  })
}


// 修改订单行项目
export function ordersItemsUpdate(data) {
  return request({
    url:'/Crm.Orders/modifyOrderLine',
    method:'post',
    data:data
  })
}

// 订单删除
export function ordersDelete(data) {
  return request({
    url:'/Crm.Orders/deleteOrder',
    method:'post',
    data:data
  })
}

// 订单列表
export function ordersList(data) {
  return request({
    url:'/Crm.Orders/index',
    method:'post',
    data:data
  })
}

// 删除订单行项目
export function ordersLineDelete(data) {
  return request({
    url:'/Crm.Orders/deleteOrderLine',
    method:'post',
    data:data
  })
}
// CRM订单行项目添加
export function ordersLineAdd(data) {
  return request({
    url:'/Crm.Orders/addOrderLine',
    method:'post',
    data:data
  })
}
// CRM订单审核
export function orderVerify(data) {
  return request({
    url:'/Crm.Orders/reviewOrder',
    method:'post',
    data:data
  })
}
// CRM订单返审核
export function orderDeaudit(data) {
  return request({
    url:'/Crm.Orders/returnOrder ',
    method:'post',
    data:data
  })
}
// CRM返审采购确认
export function orderPurchaseRetrials(data) {
  return request({
    url:'/Crm.Orders/orderPurchaseRetrials',
    method:'post',
    data:data
  })
}
// CRM关闭订单
export function closeOrder(data) {
  return request({
    url:'/Crm.Orders/closeOrder',
    method:'post',
    data:data
  })
}
// 关闭订单行
export function closeOrderLine(data) {
  return request({
    url:'/Crm.Orders/closeOrderLine',
    method:'post',
    data:data
  })
}
// 撤回关闭订单
export function withdrawCloseOrder(data) {
  return request({
    url:'/Crm.Orders/withdrawCloseOrder',
    method:'post',
    data:data
  })
}
// 撤回关闭订单行
export function withdrawCloseOrderLine(data) {
  return request({
    url:'/Crm.Orders/withdrawCloseOrderLine',
    method:'post',
    data:data
  })
}
// CRM再次购买
export function buyAgain(data) {
  return request({
    url:'/Crm.Orders/buyAgain',
    method:'post',
    data:data
  })
}
// CRM导入EXCEL到订单
export function ImportExcelToOrder(data) {
  return request({
    url:'/Crm.Orders/importOrderLines',
    method:'post',
    data:data
  })
}
// // 导出订单到EXCEL
// export function exportOrderToExcel(params) {
//   return request({
//     url:'/Crm.Orders/exportOrderToExcel',
//     method:'get',
//     params:params,
//     responseType: "blob"
//   });
// }
// 导出订单
export function exportOrderToExcel(params) {
  return request({
    url:'/Crm.Orders/exportOrders',
    method:'get',
    params:params,
    responseType: "blob"
  });
}
// 导出订单未发数到EXCEL
export function exportOrderUnsettledNumberToExcel(params) {
  return request({
    url:'/Crm.Orders/exportOrderUnsettledNumberToExcel',
    method:'get',
    params:params,
    responseType: "blob"
  });
}

// 历史订单
export function orderHistory(data) {
  return request({
    url:'/Crm.History/order_list',
    method:'post',
    data:data
  })
}


// 订单销售历史
export function salesOrderHistory(params) {
  return request({
    url:'/Crm.Orders/salesOrderHistory',
    method:'get',
    params:params
  })
}
// 订单销售历史
export function SalesHistorySummary(params) {
  return request({
    url:'/Crm.Orders/SalesHistorySummary',
    method:'get',
    params:params
  })
}
// 销售历史导出EXCEL
export function exportSalesHistoryToExcel(params) {
  return request({
    url:'/Crm.Orders/exportSalesHistoryToExcel',
    method:'get',
    params:params,
    responseType: "blob"
  });
}
// 获取订单信息
export function orderReminder(params) {
  return request({
    url:'/Crm.Orders/orderReminder',
    method:'get',
    params:params
  })
}

// // 计划跟踪
// export function OrderLineList(params) {
//   return request({
//     url:'/CRM.PlanTracking/OrderLineList',
//     method:'get',
//     params:params
//   })
// }
// // 计划跟踪导出EXCEL
// export function ExportOrderLinesToExcel(params) {
//   return request({
//     url:'/CRM.PlanTracking/ExportOrderLinesToExcel',
//     method:'get',
//     params:params,
//     responseType: "blob"
//   });
// }
// // 计划跟踪导入EXCEL
// export function importData(data) {
//   return request({
//     url:'/Crm.PlanTracking/Import_data',
//     method:'post',
//     data:data
//   })
// }

// // 同步金蝶采购申请单
// export function syncRequisition(data) {
//   return request({
//     url:'/Crm.Orders/syncRequisition',
//     method:'post',
//     data:data
//   })
// }

// //同步采购申请单
// export function NewsyncRequisition(data) {
//   return request({
//     url:'/Crm.Orders/new_syncRequisition',
//     method:'post',
//     data:data
//   })
// }

// // 一键业务确认
// export function confirm(data) {
//   return request({
//     url:'/Crm.Orders/confirm',
//     method:'post',
//     data:data
//   })
// }

// // 订单详情表头
// export function HeaderCustomization(data) {
//   return request({
//     url:'/Crm.Orders/HeaderCustomization',
//     method:'post',
//     data:data
//   })
// }

// //批量释放
// export function TransitAllocationAll(data) {
//   return request({
//     url:'/Crm.PlanTracking/CancelInTransitAllocationAll',
//     method:'post',
//     data:data
//   })
// }

//导出
export function OrdersExport(params) {
  return request({
    url:'/Crm.Orders/orders_export',
    method:'get',
    params:params,
    responseType: "blob"
  });
}

// 提交订单
export function submitOrder(data) {
  return request({
    url:'/Crm.Orders/submitOrder',
    method:'post',
    data:data
  })
}

// // 撤回订单提交
// export function cancelOrderSubmission(data) {
//   return request({
//     url:'/Crm.Orders/cancelOrderSubmission',
//     method:'post',
//     data:data
//   })
// }

// 计划确认
export function planConfirmed(data) {
  return request({
    url:'/Crm.Orders/planConfirmed',
    method:'post',
    data:data
  })
}
// 计划撤回
export function planWithdrawn(data) {
  return request({
    url:'/Crm.Orders/planWithdrawn',
    method:'post',
    data:data
  })
}

// 单据下拉框
export function documentEnumeration(data) {
  return request({
    url:'/Crm.Orders/documentEnumeration',
    method:'post',
    data:data
  })
}

// 计划交期
export function plannedDeliveryDate(data) {
  return request({
    url:'/Crm.Orders/plannedDeliveryDate',
    method:'post',
    data:data
  })
}

// 最终计划交期
export function finalPlannedDeliveryDate(data) {
  return request({
    url:'/Crm.Orders/finalPlannedDeliveryDate',
    method:'post',
    data:data
  })
}
// 评审列表
export function reviewList(data) {
  return request({
    url:'/Crm.Orders/ReviewList',
    method:'post',
    data:data
  })
}
// 锁库
export function stockLock(data) {
  return request({
    url:'/Crm.Orders/stockLock',
    method:'post',
    data:data
  })
}

// 生成出运计划单
export function addShippingPlan(data) {
  return request({
    url:'/Crm.Orders/addShippingPlan',
    method:'post',
    data:data
  })
}
// 取消客户库存订单
export function cannelOrderItems(data) {
  return request({
    url:'/Crm.History/cannelOrderItems',
    method:'post',
    data:data
  })
}
// 分配库存
export function inventoryAllocation(data) {
  return request({
    url:'/Crm.Orders/InventoryAllocation',
    method:'post',
    data:data
  })
}
// 取消分配库存
export function cancelInventoryAllocation(data) {
  return request({
    url:'/Crm.Orders/cancelInventoryAllocation',
    method:'post',
    data:data
  })
}
// 库存详情
export function stockDetails(data) {
  return request({
    url:'/Crm.Product/stockDetails',
    method:'post',
    data:data
  })
}
// 分配详情
export function allocationDetails(data) {
  return request({
    url:'/Crm.Orders/allocationDetails',
    method:'post',
    data:data
  })
}
// 分配详情 取消分配
export function cancelAllocation(data) {
  return request({
    url:'/Crm.Allocation/cancel',
    method:'post',
    data:data
  })
}

// // 导入EXCEL到评审
// export function ImportEXCELReview(data) {
//   return request({
//     url:'/Crm.Orders/ImportEXCELReview',
//     method:'post',
//     data:data
//   })
// }
// 导出评审到EXCEL
export function exportReviewEXCEL(data) {
  return request({
    url:'/Crm.Orders/exportReviewEXCEL',
    method:'post',
    data:data,
    responseType: "blob"
  })
}
// 导出计划明细EXCEL
export function exportPlanEXCEL(data) {
  return request({
    url:'/Crm.Planned/exportPlanEXCEL',
    method:'post',
    data:data,
    responseType: "blob"
  })
}
// 同步采购交期
export function syncDates(data) {
  return request({
    url:'/Crm.Orders/syncDate',
    method:'post',
    data:data
  })
}
// 同步跟踪计划号
export function syncKd(data) {
  return request({
    url:'/Crm.Planned/sync_kd',
    method:'post',
    data:data
  })
}
// 同步金蝶采购
export function syncPurchase(data) {
  return request({
    url:'/Crm.Planned/sync_purchase',
    method:'post',
    data:data
  })
}
//同步订单要求交货日期 到 采购订单 预计交货日期1
export function syncSendDate(data) {
  return request({
    url:'/Crm.Planned/sync_send_date',
    method:'post',
    data:data
  })
}
// 客户库存订单-》导出EXCEL
export function dumpData(data) {
  return request({
    url:'/Crm.History/dumpData',
    method:'post',
    data:data,
    responseType: "blob"
  })
}
// 客户库存订单-》获取重量体积
export function total_info(data) {
  return request({
    url:'/Crm.History/total_info',
    method:'post',
    data:data
  })
}

// 删除计划
export function deletePlanned(data) {
  return request({
    url:'/Crm.Planned/deletePlanned',
    method:'post',
    data:data
  })
}
// 添加计划行
export function addPlannedLine(data) {
  return request({
    url:'/Crm.Planned/addPlannedLine',
    method:'post',
    data:data
  })
}
// 增加已有计划行
export function savePlannedLine(data) {
  return request({
    url:'/Crm.Planned/savePlannedLine',
    method:'post',
    data:data
  })
}
// 计划完成
export function planCompleted(data) {
  return request({
    url:'/Crm.Planned/planCompleted',
    method:'post',
    data:data
  })
}

// 修改计划表头
export function modifyPlanHeader(data) {
  return request({
    url:'/Crm.Planned/modifyPlanHeader',
    method:'post',
    data:data
  })
}

// 计划详情
export function programDetails(data) {
  return request({
    url:'/Crm.Planned/programDetails',
    method:'post',
    data:data
  })
}
// 计划列表
export function planList(data) {
  return request({
    url:'/Crm.Planned/planList',
    method:'post',
    data:data
  })
}
// 删除计划行
export function deleteScheduleLine(data) {
  return request({
    url:'/Crm.Planned/deleteScheduleLine',
    method:'post',
    data:data
  })
}
// 修改计划行
export function modifyScheduleLine(data) {
  return request({
    url:'/Crm.Planned/modifyScheduleLine',
    method:'post',
    data:data
  })
}
// 创建打包单
export function addDelivery(data) {
  return request({
    url:'/Crm.Planned/addDelivery ',
    method:'post',
    data:data
  })
}
// 备货单列表
export function deliveryList(data) {
  return request({
    url:'/Crm.Delivery/deliveryList',
    method:'post',
    data:data
  })
}
// 备货单详情
export function deliveryDetails(data) {
  return request({
    url:'/Crm.Delivery/deliveryDetails',
    method:'post',
    data:data
  })
}
// 删除备货单
export function deleteDelivery(data) {
  return request({
    url:'/Crm.Delivery/deleteDelivery',
    method:'post',
    data:data
  })
}
// 提交备货单
export function submitDelivery(data) {
  return request({
    url:'/Crm.Delivery/submitDelivery',
    method:'post',
    data:data
  })
}
// 删除备货单行
export function deleteDeliveryLine(data) {
  return request({
    url:'/Crm.Delivery/deleteOrderLine',
    method:'post',
    data:data
  })
}
// 修改打包单表头
export function saveDelivery(data) {
  return request({
    url:'/Crm.Delivery/save',
    method:'post',
    data:data
  })
}
// 装箱单
export function packingList(data) {
  return request({
    url:'/Crm.Planned/packing',
    method:'post',
    data:data
  })
}
// 导出装箱单到EXCEL
export function exportPackingEXCEL(data) {
  return request({
    url:'/Crm.Planned/exportPackingEXCEL',
    method:'post',
    data:data,
    responseType: "blob"
  });
}

// 生成出库单
export function outboundOrders(data) {
  return request({
    url:'/Crm.Planned/outboundOrders',
    method:'post',
    data:data
  })
}
// 出库单列表
export function outboundOrderList(data) {
  return request({
    url:'/Crm.Planned/outboundOrderList',
    method:'post',
    data:data
  })
}
// 出库单详情
export function outboundOrderDetails(data) {
  return request({
    url:'/Crm.Planned/outboundOrderDetails',
    method:'post',
    data:data
  })
}
// 删除出库单
export function deleteOutboundOrde(data) {
  return request({
    url:'/Crm.Planned/deleteOutboundOrder',
    method:'post',
    data:data
  })
}
// 提交出库单
export function outboundOrder(data) {
  return request({
    url:'/Crm.Planned/outboundOrder',
    method:'post',
    data:data
  })
}

// 拆包
export function unBoxing(data) {
  return request({
    url:'/Crm.Planned/unBoxing',
    method:'post',
    data:data
  })
}
// 拆包单列表
export function unboxingList(data) {
  return request({
    url:'/Crm.Planned/unboxingList',
    method:'post',
    data:data
  })
}
// 拆包单详情
export function unBoxingDetails(data) {
  return request({
    url:'/Crm.Planned/unBoxingDetails',
    method:'post',
    data:data
  })
}
// 修改拆包单行
export function modifyUnpackingOrder(data) {
  return request({
    url:'/Crm.Planned/modifyUnpackingOrder',
    method:'post',
    data:data
  })
}
// 提交拆包单
export function submitUnpackingOrder(data) {
  return request({
    url:'/Crm.Planned/submitUnpackingOrder',
    method:'post',
    data:data
  })
}
// 撤回拆包单
export function withdrawUnpackingOrder(data) {
  return request({
    url:'/Crm.Planned/withdrawUnpackingOrder',
    method:'post',
    data:data
  })
}
// 删除拆包单
export function deleteUnpackingOrder(data) {
  return request({
    url:'/Crm.Planned/deleteUnpackingOrder',
    method:'post',
    data:data
  })
}


// 订单评审体积重量
export function volumeWeight(data) {
  return request({
    url:'/Crm.Orders/volumeWeight',
    method:'post',
    data:data
  })
}

// 订单行项目添加
export function addOrderLine(data) {
  return request({
    url:'/Crm.Orders/addOrderLine',
    method:'post',
    data:data
  })
}
// 订单产品搜索
export function orderProductSearch(data) {
  return request({
    url:'/Crm.Orders/productSearch',
    method:'post',
    data:data
  })
}

// 分配在途库存
export function InventoryTransitAllocation(data) {
  return request({
    url:'/Crm.Orders/InventoryTransitAllocation',
    method:'post',
    data:data
  })
}
// 取消在途分配
export function cancelAllocationInTransit(data) {
  return request({
    url:'/Crm.Orders/cancelAllocationInTransit',
    method:'post',
    data:data
  })
}
// 生成请购单
export function GeneratePurchaseRequisition(data) {
  return request({
    url:'/Crm.Orders/GeneratePurchaseRequisition',
    method:'post',
    data:data
  })
}
// 取消请购单
export function cancelRequisition(data) {
  return request({
    url:'/Crm.Orders/cancelRequisition',
    method:'post',
    data:data
  })
}
// 取消委外订单
export function cancelOutsourcing(data) {
  return request({
    url:'/Crm.Orders/cancelOutsourcing',
    method:'post',
    data:data
  })
}
// 申请委外订单
export function outsourcingApplication(data) {
  return request({
    url:'/Crm.Orders/outsourcingApplication',
    method:'post',
    data:data
  })
}
// 历史批次
export function historicalBatches(data) {
  return request({
    url:'/Crm.Orders/historicalBatches',
    method:'post',
    data:data
  })
}

// 合并计划
export function mergePlanned(data) {
  return request({
    url:'/Crm.Planned/merge_planned',
    method:'post',
    data:data
  })
}
// 计划行剩余计划数转移计划
export function changePlanned(data) {
  return request({
    url:'/Crm.Planned/change_planned',
    method:'post',
    data:data
  })
}
// 订单评审枚举
export function OrderreviewEnums(data) {
  return request({
    url:'/Crm.Orderreview/Enums',
    method:'post',
    data:data
  })
}
//提交预测订单行
export function auditOrdersLine(data) {
  return request({
    url:'/Crm.Ordersnew/audit_orders_line',
    method:'post',
    data:data
  })
}
//订单变更单新增
export function ordersChangeAdd(data) {
  return request({
    url:'/Crm.Orderschange/add',
    method:'post',
    data:data
  })
}
//订单变更单操作
export function ordersChangeSave(data) {
  return request({
    url:'/Crm.Orderschange/save',
    method:'post',
    data:data
  })
}
//订单变更单详情
export function ordersChangeView(data) {
  return request({
    url:'/Crm.Orderschange/view',
    method:'post',
    data:data
  })
}
//订单变更单列表
export function ordersChangeIndex(data) {
  return request({
    url:'/Crm.Orderschange/index',
    method:'post',
    data:data
  })
}
//订单变更单列表
export function purchaserOrderlist(data) {
  return request({
    url:'/Crm.Purchaser/order_list',
    method:'post',
    data:data
  })
}

//订单变更单列表
export function purchaserBatchUpdate(data) {
  return request({
    url:'/Crm.Purchaser/batch_update',
    method:'post',
    data:data
  })
}
//订单变更单列表
export function purchaserOrderExport(data) {
  return request({
    url:'/Crm.Purchaser/export_list',
    method:'post',
    data:data,
    responseType: "blob"
  })
}
// 切换产品品牌
export function switchProductBrand(data) {
  return request({
    url:'/Crm.Quote/switchProductBrand',
    method:'post',
    data:data,
  })
}
// 复制
export function QuoteCopyItemField(data) {
  return request({
    url:'/Crm.Quote/copyItemField',
    method:'post',
    data:data
  })
}
export function OrdersCopyItemField(data) {
  return request({
    url:'/Crm.Orders/copyItemField',
    method:'post',
    data:data
  })
}
// 订单跟进列表
export function orderFollowList(data) {
  return request({
    url:'/Crm.Ordersfollow/orderlist',
    method:'post',
    data:data
  })
}
// 订单跟进更新
export function orderFollowUpdate(data) {
  return request({
    url:'/Crm.Ordersfollow/update',
    method:'post',
    data:data
  })
}
// 订单跟进刷新
export function orderFollowRefresh(data) {
  return request({
    url:'/Crm.Ordersfollow/refresh',
    method:'post',
    data:data
  })
}

// 订单取消库存汇总列表
export function orderCancelList(data) {
  return request({
    url: '/Crm.Ordersfollow/cancel_list',
    method: 'post',
    data: data
  })
}

// 订单取消库存汇总导出（全量）
export function exportOrderCancel(data) {
  return request({
    url: '/Crm.Ordersfollow/export_cancels',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js